import { render } from "./index.vue?vue&type=template&id=31a200be&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=31a200be&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-31a200be"

export default script